import _ from 'lodash'

import  fieldHelpers  from '../../../../../ui-formly/fieldHelpers/index'
import selectAsyncUtils from "../../../../../ui-formly/types/selectAsync/utils"
import { default as server } from "../../../Server"
import { GameConfigurationController } from "./gameConfigurationController"
import { RowCommandController } from "./RowCommandController"

function formlyGameConfigurations(authService) {
  var formly = {
    key: "GameConfigurations",
    name: "GameConfigurations",
    data: {
      averagePar: 0.0,
      onModelChange: modelChange,
    },
    controller: GameConfigurationController,
    template: require("!html-loader!./gameConfiguration.html").default,
    templateOptions: {
      addText: "Add Configuration",
      readFields: getReadFields(),
      editFields: getWriteFields(authService),
    },
  }

  return [formly]
}

function modelChange(newGameConfigurations, oldGameConfigurations, $scope) {
  var averagePar = getAveragePar(newGameConfigurations)
  $scope.options.data.averagePar = averagePar
}

function parChanged($viewValue, $modelValue, scope) {
  var machineConfigurationFieldScope = scope.$parent.$parent.$parent.$parent.$parent.$parent.$parent.$parent
  var model = machineConfigurationFieldScope.model
  var options = machineConfigurationFieldScope.options

  var gameConfigurations = model.GameConfigurations

  var averagePar = getAveragePar(gameConfigurations)
  var averageParWithProgressiveContribution = getAverageParWithProgressiveContribution(gameConfigurations)
  options.data.averagePar = averagePar
  options.data.averageParWithProgressiveContribution = averageParWithProgressiveContribution
}

function getAverageParWithProgressiveContribution(gameConfigurations) {
  var count = gameConfigurations ? gameConfigurations.length : 0
  if (count > 0) {
    var totalPar = _.reduce(gameConfigurations, function (sum, gameConfiguration) { return sum + gameConfiguration.Par + (gameConfiguration.ProgressiveIncrementPercentage || 0) }, 0.0)
    return totalPar / count
  }
}

function getAveragePar(gameConfigurations) {
  var count = gameConfigurations ? gameConfigurations.length : 0
  if (count > 0) {
    var totalPar = _.reduce(gameConfigurations, function (sum, gameConfiguration) { return sum + gameConfiguration.Par }, 0.0)
    return totalPar / count
  }
}

function getReadFields() {
  return [
    readonlyField({ key: "ThemeName", label: "Theme", className: "col-xs-2" }),
    readonlyField({ key: "GameSeries", label: "Series/Family", className: "col-xs-2"  }),
    readonlyField({ key: "DenominationName", label: "Denomination", className: "col-xs-2"  }),
    readonlyField({ key: "MinBet", label: "Min Bet", className: "col-xs-2"  }),
    readonlyField({ key: "MaxBet", label: "Max Bet", className: "col-xs-2"  }),
    readonlyField({ key: "Par", label: "Par", className: "col-xs-2"  }),
    readonlyField({ key: "Payline", label: "Payline", className: "col-xs-2"  }),
    readonlyField({ key: "MaxLiability", label: "MaxLiability", className: "col-xs-2"  }),
    readonlyField({ key: "ProgressiveIncrementPercentage", label: "Prog Inc%", className: "col-xs-2"  }),
    readonlyField({ key: "PaytableId", label: "Paytable ID", className: "col-xs-2"  }),
    readonlyField({ key: "Volatility", label: "Volatility", className: "col-xs-2"  }),
    {
      key: "copyEditDeleteButtons",
      templateOptions: {
        label: " ",
      },
      className: "col-xs-3 col-xs-offset-9",
      template: `
      <div>
        <div class="pull-right">
          <div class="form-group btn-group">
            <div class="btn btn-secondary game-config-btn" ng-click="rowCommand('copyRow', model, form)">
              <i class="glyphicon glyphicon-copy"></i>
            </div>
          </div>
          <div class="form-group btn-group">
            <div class="btn btn-secondary game-config-btn" ng-click="rowCommand('editRow', model, form)">
              <i class="glyphicon glyphicon-pencil"></i>
            </div>
            <div class="btn btn-danger game-config-btn" ng-click="rowCommand('deleteRow', model, form)">
              <i class="glyphicon glyphicon-remove"></i>
            </div>
          </div>
        </div>
      </div>
      `,
      controller: RowCommandController,
    },
  ]
}

function getWriteFields(authService) {
  return [
    ...fieldHelpers.columnLayout(
      [
        {
          key: "ThemeId",
          name: "ThemeId",
          type: "selectAsync",
          templateOptions: {
            required: true,
            label: "Theme",
            query: selectAsyncUtils.getQuery(server, "themeQuery"),
            saveNewItem: selectAsyncUtils.getSave(server, "themeSave"),
            showAddButton: authService.hasPermission("machineEdit"),
            getDefaultItem: function (model) {
              return {
                Id: model.ThemeId,
                Name: model.ThemeName,
              }
            },
            updateNameProp: "ThemeName",
          },
        },
        
        fieldHelpers.simpleStringField({ key: "GameSeries", label: "Series/Family" }),
        {
          key: "DenominationId",
          name: "DenominationId",
          type: "selectAsync",
          templateOptions: {
            required: true,
            label: "Denomination",
            query: selectAsyncUtils.getQuery(server, "denominationQuery"),
            saveNewItem: selectAsyncUtils.getSave(server, "denominationSave"),
            showAddButton: authService.hasPermission("machineEdit"),
            getDefaultItem: function (model) {
              return {
                Id: model.DenominationId,
                Name: model.DenominationName,
              }
            },
            updateNameProp: "DenominationName",
          },
        },
        
        fieldHelpers.simpleNumberField({
          key: "MinBet",
          label: "Minimum Bet",
          min: 0,
        }),
        fieldHelpers.simpleNumberField({
          key: "MaxBet",
          label: "Maximum Bet",
          min: 0,
        }),
        fieldHelpers.simplePercentageField({
          key: "Par",
          label: "Par",
          min: 0,
          max: 100,
        }),
        fieldHelpers.simpleStringField({ key: "Payline", label: "Payline" }),
        fieldHelpers.simpleStringField({ key: "MaxLiability", label: "~ Max Liability" }),
        {
          key: 'ProgressiveIncrementPercentage',
          name: 'ProgressiveIncrementPercentage',
          type: 'input',
          modelOptions: {
            debounce: {
              'default': 500,
              'blur': 0
            }
          },
          templateOptions: {
            label: 'Prog Inc%',
            type: 'number',
            min: 0,
            max: 100,
            addonRight: {
              class: 'fa fa-percent'
            },
            onChange: parChanged
          },
          className: 'col-xs-3',
          watcher: {
            expression(field, scope){
              let  mainFormScope = scope
              while(mainFormScope && !mainFormScope.ctrl){
                mainFormScope = mainFormScope.$parent
              }
              return mainFormScope.ctrl.model.Progressive
            },
            listener(field, progressive, _, scope){
              field.templateOptions.readonly = !progressive
              if(!progressive){
                scope.model[field.key] = undefined
              }
            }
          }
        },
        fieldHelpers.simpleStringField({ key: "PaytableId", label: "Paytable ID" }),
        {
          key: 'Volatility',
          type: 'select',
          templateOptions: {
            label: 'Volatility',
            options: [
              {
                label: 'Low',
                value: 'Low'
              },
              {
                label: 'Medium',
                value: 'Medium'
              },
              {
                label: 'High',
                value: 'High'
              }
            ],
            labelProp: 'label',
            valueProp: 'value'
          }
        },
      ],
      4
    ),
    {
      key: "submitCancelButtons",
      templateOptions: {
        label: " ",
      },
      className: "col-xs-3 col-xs-offset-9",
      wrapper: ["bootstrapLabel", "bootstrapHasError"],
      controller: RowCommandController,
      template: `<div>
          <i class="glyphicon glyphicon-ok text-secondary" ng-click="rowCommand('submitRowEdit', model, form)" />
          <i class="glyphicon glyphicon-remove text-danger" ng-click="rowCommand('cancelRowEdit', model, form)" />
        </div>`,
    },
  ]
}

function readonlyField(config) {
  const templateOptions = {
    label: config.label,
    formatter: config.formatter,
  }

  return {
    key: config.key,
    name: config.key,
    templateOptions,
    controller: readonlyFieldController,
    template: `<div class="form-control-static" ng-bind-html="getValue(model[options.key])"></div>`,
    wrapper: ['bootstrapLabel', 'bootstrapHasError'],
    className: config.className || '',
  }
}

class readonlyFieldController {
  constructor($scope) {
    const to = $scope.to
    $scope.getValue = (value) => {
      return value === undefined || value === null
        ? undefined
        : to.formatter ? to.formatter(this, value) : value.toString()
    }
  }
}
readonlyFieldController.$inject = ['$scope']


export default formlyGameConfigurations

